"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertToTreeData = exports.convertToAPIData = void 0;
/*
 * API -> UI conversion
 --------------------------------------------------------*/

function prepareItemForTree(item) {
  var _item$content;

  if (item.linkText) {
    item.title = item.linkText;
  }

  if (item.path) {
    item.pathName = item.path;
  }

  if (item.children) {
    item.children = convertToTreeData(item.children);
  }

  if (item.displayFrom) {
    item.displayFrom = new Date(item.displayFrom);
  }

  if (item.displayTo) {
    item.displayTo = new Date(item.displayTo);
  }

  if (item !== null && item !== void 0 && (_item$content = item.content) !== null && _item$content !== void 0 && _item$content.id) {
    item.identifier = item.content.id;
  }

  return item;
}

var convertToTreeData = function convertToTreeData(data) {
  if (data !== null && data !== void 0 && data.map) {
    return data.map(function (item) {
      return prepareItemForTree(item);
    });
  } else {
    return prepareItemForTree(data);
  }
};
/*
 * UI -> API conversion
 --------------------------------------------------------*/


exports.convertToTreeData = convertToTreeData;

var convertToAPIData = function convertToAPIData(data) {
  if ((data === null || data === void 0 ? void 0 : data.length) > 0) {
    return data.map(function (item) {
      var _apiItem$children;

      var id;

      if (typeof item.id === 'string') {
        // Newly created items' ID is an IRI (which is a string) e.g. "/menu-item/1"
        // originID gives us the created item's ID as an int
        id = item.originId;
      } else {
        id = item.id;
      }

      var apiItem = {
        id: id,
        children: item.children || []
      };

      if ((apiItem === null || apiItem === void 0 ? void 0 : (_apiItem$children = apiItem.children) === null || _apiItem$children === void 0 ? void 0 : _apiItem$children.length) > 0) {
        apiItem.children = convertToAPIData(apiItem.children);
      }

      return apiItem;
    });
  }
};

exports.convertToAPIData = convertToAPIData;